import { SizeGangSpec } from '../types/techPack';
import { BASE_PRODUCT_ID, MIN_SIDE_WITH_MARGIN_MM } from '@modules/Vector/S/Constant/stickerizer.constant.ts';

// 조각스티커의 조판 규격 정의
export const GANGING_SPEC: SizeGangSpec = {
  [BASE_PRODUCT_ID.JOGAK_STICKER]: {
    GANG_15: {
      priority: 1, // 스티커가 조판에 들어가는 사이즈가 되는지 테스트 우선순위 (낮을수록 높음)
      items_per_page: 15, // 페이지 당 스티커 개수
      rows: 5, // 페이지 당 스티커 행 개수
      columns: 3, // 페이지 당 스티커 열 개수
      bounding_box_size_mm: {
        width: 84, // 스티커 박스 가로 사이즈
        height: 60, // 스티커 박스 세로 사이즈
      },
      start_mm: {
        x: 18.5, // 스티커 박스 시작 위치 x
        y: 17, // 스티커 박스 시작 위치 y
      },
      x_gap_mm: 4, // 스티커 박스 가로 간격
      y_gap_mm: 18, // 스티커 박스 세로 간격
      tombow: {
        shape: 'circle', // 돔보마크 모양
        radius_mm: 2.5, // 돔보마크 반지름
        x_mm: 10, // 돔보마크 위치 x
        y_mm: 10, // 돔보마크 위치 y
      },
      page_size_mm: {
        width: 297, // 페이지 가로 사이즈
        height: 420, // 페이지 세로 사이즈
        direction: 'portrait', // 페이지 방향
      },
      is_hidden: false, // 페이지 비공개 여부
    },
    GANG_9: {
      priority: 2,
      items_per_page: 9,
      rows: 3,
      columns: 3,
      bounding_box_size_mm: {
        width: 84,
        height: 112,
      },
      start_mm: {
        x: 18.5,
        y: 17,
      },
      x_gap_mm: 4,
      y_gap_mm: 18,
      tombow: {
        shape: 'circle',
        radius_mm: 2.5,
        x_mm: 10,
        y_mm: 10,
      },
      page_size_mm: {
        width: 297,
        height: 420,
        direction: 'portrait',
      },
      is_hidden: false,
    },
    GANG_8: {
      priority: 3,
      items_per_page: 8,
      rows: 4,
      columns: 2,
      bounding_box_size_mm: {
        width: 128,
        height: 79.5,
      },
      start_mm: {
        x: 18.5,
        y: 17,
      },
      x_gap_mm: 4,
      y_gap_mm: 18,
      tombow: {
        shape: 'circle',
        radius_mm: 2.5,
        x_mm: 10,
        y_mm: 10,
      },
      page_size_mm: {
        width: 297,
        height: 420,
        direction: 'portrait',
      },
      is_hidden: false,
    },
    GANG_6: {
      priority: 4,
      items_per_page: 6,
      rows: 3,
      columns: 2,
      bounding_box_size_mm: {
        width: 128,
        height: 112,
      },
      start_mm: {
        x: 18.5,
        y: 17,
      },
      x_gap_mm: 4,
      y_gap_mm: 18,
      tombow: {
        shape: 'circle',
        radius_mm: 2.5,
        x_mm: 10,
        y_mm: 10,
      },
      page_size_mm: {
        width: 297,
        height: 420,
        direction: 'portrait',
      },
      is_hidden: false,
    },
    GANG_5: {
      priority: 5,
      items_per_page: 5,
      rows: 5,
      columns: 1,
      bounding_box_size_mm: {
        width: 264,
        height: 60,
      },
      start_mm: {
        x: 18.5,
        y: 17,
      },
      x_gap_mm: 0,
      y_gap_mm: 18,
      tombow: {
        shape: 'circle',
        radius_mm: 2.5,
        x_mm: 10,
        y_mm: 10,
      },
      page_size_mm: {
        width: 297,
        height: 420,
        direction: 'portrait',
      },
      is_hidden: false,
    },
    GANG_4: {
      priority: 6,
      items_per_page: 4,
      rows: 2,
      columns: 2,
      bounding_box_size_mm: {
        width: 128,
        height: 177,
      },
      start_mm: {
        x: 18.5,
        y: 17,
      },
      x_gap_mm: 4,
      y_gap_mm: 18,
      tombow: {
        shape: 'circle',
        radius_mm: 2.5,
        x_mm: 10,
        y_mm: 10,
      },
      page_size_mm: {
        width: 297,
        height: 420,
        direction: 'portrait',
      },
      is_hidden: false,
    },
    GANG_3: {
      priority: 7,
      items_per_page: 3,
      rows: 3,
      columns: 1,
      bounding_box_size_mm: {
        width: 264,
        height: 111,
      },
      start_mm: {
        x: 18.5,
        y: 17,
      },
      x_gap_mm: 4,
      y_gap_mm: 18,
      tombow: {
        shape: 'circle',
        radius_mm: 2.5,
        x_mm: 10,
        y_mm: 10,
      },
      page_size_mm: {
        width: 297,
        height: 420,
        direction: 'portrait',
      },
      is_hidden: true,
    },
  },
  [BASE_PRODUCT_ID.PLUSH_DOLL]: {
    MIN: {
      priority: 1,
      bounding_box_size_mm: {
        width: MIN_SIDE_WITH_MARGIN_MM[BASE_PRODUCT_ID.PLUSH_DOLL],
        height: MIN_SIDE_WITH_MARGIN_MM[BASE_PRODUCT_ID.PLUSH_DOLL],
      },
      is_hidden: false,
    },
    MAX: {
      priority: 2,
      bounding_box_size_mm: {
        width: 200,
        height: 200,
      },
      is_hidden: false,
    },
  },
} as const;
